import React, { useEffect } from "react";
import { useI18n } from "@/i18n/I18nProvider";
import LegalLayout from "@/components/LegalLayout";

export default function Cookies() {
  const { t } = useI18n();
  useEffect(() => {
    document.title = `${t("pages.cookiesTitle")} · ${t("brand.name")}`;
  }, [t]);

  const sections = [
    { title: null, text: t("cookiesPage.intro") },
    ...Array.from({ length: 7 }, (_, i) => ({
      title: t(`cookiesPage.s${i + 1}Title`),
      text: t(`cookiesPage.s${i + 1}Text`),
    })),
  ];
  return <LegalLayout title={t("pages.cookiesTitle")} updated={t("pages.cookiesUpdated")} sections={sections} />;
}
